import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const HeaderContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	background-color: rgba(255, 255, 255, 0.03);
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const Title = styled(Text)`
	font-size: 18px;
	font-weight: 600;
	color: #ffffff;
`;

export { HeaderContainer, Title };
